import Layout from "../include/layout";
import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import GrillestarifairesService from "./DevoirsService";
import Filarial from "../include/filarial";
import DevoirsService from "./DevoirsService";
import TypesevaluationsService from "../typesevaluations/TypesevaluationsService";
import axios from "axios";

export default function DevoirsIndex() {
    const activeLink = "DEVOIRS"

    const token = useSelector(state => state.auth.token)
    const [devoirs, setDevoirs] = useState([]);
    const [typesevaluations, setTypesEvaluations] = useState([])
    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //get liste devoirs
    //get liste cours
    const fetchDevoirs = async () => {
        try {
            const response = await DevoirsService.index(token);
            console.log("Données reçues:", response.data.data);
            setDevoirs(response.data.data);
        } catch (error) {
            console.error("Erreur lors de la récupération des devoirs:", error);
        }
        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    };

    //get liste enseignants
    const fetchTypesevaluations = async () => {
        await TypesevaluationsService.index(token)
            .then((res) => {
                //console.log(res.data.data)
                setTypesEvaluations(res.data.data.typesevaluations);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.devoirs_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                DevoirsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchDevoirs()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "numeric", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    useEffect(() => {

        fetchDevoirs();
        fetchTypesevaluations();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }

    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">

                <Filarial activeLink={activeLink} />


                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-3">
                    <h5 className="card-header">Liste des contrôles &nbsp;&nbsp;
                        <Link to={myroutes.devoirs_create}
                            className="btn btn-warning btn-sm"
                            title="Ajouter"
                        ><FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Link>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="fw-bold theme-bg-blue-white">
                                <tr style={{ color: "" }}>
                                    <th className="cell">#</th>
                                    <th className="cell">Type evaluation</th>
                                    <th className="cell">Libelle</th>
                                    <th className="cell">Description</th>
                                    <th className="cell">Date devoir</th>
                                    <th className="cell">Heure debut</th>
                                    <th className="cell">Heure Fin</th>
                                    <th className="cell">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(devoirs) && devoirs.length > 0 ? (
                                    devoirs.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {item.typesevaluations?.libelleTypeEvaluation || 'N/A'}
                                            </td>
                                            <td>{item.libelleDevoir}</td>
                                            <td>{item.descriptionDevoir}</td>
                                            <td>{dayjs(item.dateDevoir).format("DD/MM/YYYY")}</td>
                                            <td>{item.heuredebutDevoir}</td>
                                            <td>{item.heurefinDevoir}</td>
                                            <td>
                                                <div className="d-flex">
                                                    <Button
                                                        className="btn btn-sm"
                                                        variant="primary"
                                                        onClick={() => goToEdit(item.id)}
                                                        title="Modifier"
                                                    >
                                                        <i className="fas fa-edit"></i>
                                                    </Button>
                                                    &nbsp;&nbsp;
                                                    <Button
                                                        className="btn btn-sm"
                                                        variant="danger"
                                                        onClick={() => onDelete(item.id)}
                                                        title="Supprimer"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            Aucun devoir disponible
                                        </td>
                                    </tr>
                                )}
                            </tbody>



                        </table>
                    </div>
                </div>

                {/*/ Responsive Datatable */}
            </div>


        </Layout>
    )
}